import { Injectable } from '@angular/core';
import { Urls } from '@core/config/urls';
import { OldLegacyBaseApiService } from '@smartera/core';

@Injectable()
export class BranchService extends OldLegacyBaseApiService<any> {
	public dealerId = '';
	override get apiUrl() {
		return (Urls.BASE_URL.toString() + '/main/gnr/dealers/$dealerId/branches').replace('$dealerId', this.dealerId);
	}

	public setDealerId(dealerId: string) {
		this.dealerId = dealerId;
	}
}
